<template>
  <div>
    <template v-if="systemMetaData?.proxyMisconfiguration?.domain">
      <div class="d-flex align-center mb-1">
        <div class="subtitle2 mr-1" data-testid="proxy-misconfiguration-domain-label">
          {{ $t("general.domain") }}
        </div>
        <div class="body2" data-testid="proxy-misconfiguration-domain-value">
          {{ systemMetaData.proxyMisconfiguration.domain }}
        </div>
      </div>
      <div class="d-flex align-center mb-1">
        <div class="subtitle2 mr-1" data-testid="proxy-misconfiguration-last-failed-label">
          {{ $t("ticketDetails.lastFailedTest") }}
        </div>
        <div class="body2" data-testid="proxy-misconfiguration-last-failed-value">
          {{ getFormattedDateTime(systemMetaData.proxyMisconfiguration.lastFailedTestTime) }}
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import type { TicketDetails } from "@/_store/tickets/tickets.module";
import { useTicketPreviewGeneralInfo } from "@/composables/useTicketPreviewGeneralInfo";

export default defineComponent({
  props: {
    ticketDetails: {
      type: Object as PropType<TicketDetails>,
      required: true,
    },
  },
  setup(props) {
    const systemMetaData = computed(() => props.ticketDetails?.sections?.systemMetaData);

    const { getFormattedDateTime } = useTicketPreviewGeneralInfo(props.ticketDetails);

    return {
      systemMetaData,
      getFormattedDateTime,
    };
  },
});
</script>
